import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { SignupList } from "@/components/nobo/SignupList";

const signIn = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/organiser";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

const Gate = ({ title, text, children }) => (
  <div className="card org-gate">
    <h2>{title}</h2>
    <p className="sub">{text}</p>
    {children}
  </div>
);

export default function Organiser() {
  const location = useLocation();
  const [user, setUser] = useState(location.state?.user ?? null);
  const [checked, setChecked] = useState(Boolean(location.state?.user));

  useEffect(() => {
    if (checked) return;
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(null)).finally(() => setChecked(true));
  }, [checked]);

  const signOut = async () => {
    await api.post("/auth/logout");
    setUser(null);
  };

  return (
    <div className="nobo">
      <div className="wrap">
        <div className="top">
          <Link to="/" className="logo" data-testid="organiser-home-link">nobo<b>.</b></Link>
          {user && <button type="button" className="pill" onClick={signOut} data-testid="sign-out-button">sign out</button>}
        </div>
        <h1 className="org-title">sign-ups</h1>
        {!checked && <p className="lede" data-testid="organiser-loading">checking...</p>}
        {checked && !user && (
          <Gate title="organisers only" text="Sign in with the Google account that runs NOBO to see every waitlist request.">
            <button className="go" onClick={signIn} data-testid="google-sign-in-button">sign in with Google</button>
          </Gate>
        )}
        {checked && user && !user.is_organiser && (
          <Gate title="not on the crew list" text={`${user.email} doesn't have organiser access. Sign out and use the NOBO account.`}>
            <button className="go" onClick={signOut} data-testid="not-organiser-sign-out">sign out</button>
          </Gate>
        )}
        {checked && user?.is_organiser && <SignupList />}
      </div>
    </div>
  );
}
